<template>
  <div class="survey-start">
    <div class="content">
      <h1 class="mb-6 mb-lg-9">{{ greeting }}</h1>
      <h2 class="mb-6 mb-lg-7">
        Você está a poucos passos para começar a sua nova jornada com a
        Blitzpay!
      </h2>
      <p class="mb-lg-7">
        Para melhor experiência na Blitzpay, por favor responda algumas rápidas
        perguntas para te conhecermos melhor.
      </p>

      <bp-button
        class="d-lg-none cta-button"
        label="Vamos lá!"
        @click="$emit('advance')"
      />
      <div class="d-none d-lg-block">
        <bp-button label="Vamos lá!" @click="$emit('advance')" />
      </div>
    </div>

    <img :src="image" alt="mountain" />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("user", ["survey"]),
    greeting() {
      const name = this.$user.user?.name;
      const greeting = "Seja bem-vindo" + (name ? ", " + name : "") + "!";
      return greeting;
    },
    image() {
      return window.innerWidth > 991
        ? require("@/assets/images/auth-after-register/mountain.png")
        : require("@/assets/images/auth-after-register/mountain-mobile.png");
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-right {
  .content {
    @media screen and (min-width: 992px) {
      padding-right: 0;
    }
  }
}
</style>
